import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPlayingCards3 = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.256 5.25H14A4.75 4.75 0 0 1 18.75 10v4.69a3.22 3.22 0 0 0 1.288-2.403l.307-5.11c.109-1.805-1.241-3.383-3.016-3.527l-1.03-.083a3.14 3.14 0 0 0-3.043 1.683m5.494 11.184c1.544-.677 2.66-2.19 2.771-4.028l.307-5.11c.159-2.636-1.815-4.944-4.408-5.154l-1.03-.083a4.59 4.59 0 0 0-4.376 2.328 4.59 4.59 0 0 0-4.432-2.14l-1.028.12c-2.584.3-4.476 2.675-4.225 5.305l.485 5.096a4.69 4.69 0 0 0 2.436 3.708V17A4.75 4.75 0 0 0 10 21.75h4A4.75 4.75 0 0 0 18.75 17zM7.725 3.751a3.14 3.14 0 0 1 3.054 1.499H10A4.75 4.75 0 0 0 5.25 10v4.614a3.23 3.23 0 0 1-.959-2.018L3.806 7.5C3.635 5.7 4.93 4.076 6.697 3.87zM6.75 10A3.25 3.25 0 0 1 10 6.75h4A3.25 3.25 0 0 1 17.25 10v7A3.25 3.25 0 0 1 14 20.25h-4A3.25 3.25 0 0 1 6.75 17zm6.706-.168a1.75 1.75 0 0 0-2.912 0l-1.798 2.697a1.75 1.75 0 0 0 0 1.942l1.798 2.697a1.75 1.75 0 0 0 2.912 0l1.798-2.697a1.75 1.75 0 0 0 0-1.942zm-1.664.832a.25.25 0 0 1 .416 0l1.798 2.697a.25.25 0 0 1 0 .278l-1.798 2.697a.25.25 0 0 1-.416 0l-1.798-2.697a.25.25 0 0 1 0-.278z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPlayingCards3;
